<template>
  <div class="relative">
    <loader ref="loader"/>

    <div id="step-1" v-if="step == 1">
      <app-header></app-header>

      <div class="container content">
        <router-link :to="{name: 'Start', params: {id: 1}}" class="back">
          <font-awesome-icon icon="angle-left"/>
          <span>Вернуться</span>
        </router-link>

        <div class="no-players">
          <div class="text">
            <h1 class="center">Программа «{{test.name}}»</h1>
            <p>Правила прохождения тестирования:</p>
            <p class="descr">{{test.description}}</p>

            <div class="round">
              Время прохождения - <span class="no-wrap"><b>{{test.time}}</b> минут</span>
            </div>

            <div class="btn btn-lg" @click="startTest">
              Приступить
            </div>

          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>

    <div id="step-2" v-if="step == 2">
      <Test :test="test" :questions="questions" @restartTest="restartTest" ref="test"/>
    </div>

  </div>
</template>

<script>
  import TestsService from '@/services/TestsService'
  import Test from './Test'

  export default {
    name: 'test-start',
    components: {
      Test
    },
    data () {
      return {
        step: 1,
        questions: [],
        question: {},
        question_answers: []
      }
    },
    computed: {
      test () {
        return this.$store.getters.test
      },
      testId () {
        return this.$route.params.id
      },
      orgSlug () {
        return this.$route.params.slug
      }
    },
    methods: {
      startTest () {
        let player = this.$store.getters.getPlayer
        TestsService.postStartTest(this.orgSlug, player.id || 1, this.testId).then(
          (response) => {
            this.step = 2
          }
        )
      },
      restartTest () {
        this.step = 1
      }
    },
    mounted () {
      this.$refs.loader.show()

      TestsService.getTest(this.orgSlug, this.testId).then(
        (response) => {
          this.$store.dispatch('setTest', response)
          this.$refs.loader.hide()
          this.questions = response.test_questions
          this.startTest()
        }
      )
    },
    created () {
      window.addEventListener('beforeunload', (event) => {
        this.$refs.test.finishTest(false)
        return undefined
      })
    }
  }
</script>

<style scoped lang="scss">
  .no-wrap {
    white-space: nowrap;
  }
  .content {
    min-height: calc(100vh - 212px);
  }

  .no-players {
    margin: 10vh 0;

    h1 {
      margin: 0 0 1em 0;
    }
    .text {
      color: #000 !important;
    }
    p {
      line-height: 1.3em;
    }

    .descr {
      white-space: pre-wrap;
      width: 730px;
      max-width: 100%;
      margin: 0 auto;
      text-align: left;
      font-size: 20px;
    }
    .round {
      background-color: #fff;
      border-radius: 6px;
      border: 1px solid $light-blue;
      width: 417px;
      max-width: 100%;
      margin: 3em auto;
      box-sizing: border-box;
      padding: 25px;
      @media screen and (max-width: 500px) {
        padding: 20px;
      }
      text-align: center;
      font-weight: 300;
      font-size: 18px;
      line-height: 1.5em;
    }
    .btn {
      width: 730px;
      font-size: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/game/TestStart.vue